import { Heading, Image, TextPassage } from '@petsmart-ui/sparky';
import { dataLayerPush, getBaseUrlJoined, layoutEvents } from '@libs/analytics';

import Link from 'next/link';
import type { MenuCardProps } from './types';

export const trackingData = (data: object) => Object.assign(data, { ...layoutEvents.headerMenuNavClick });

export function MenuCard({ card, category, onClick }: Readonly<MenuCardProps>) {
    const href = card.link?.webUrl ?? '#';
    const imgSrc = card.image.remoteMobileImageUrl ?? card.image.remoteDesktopImageUrl ?? '';
    return (
        <li className="menu-card">
            <Link
                onClick={() => {
                    onClick?.();
                    dataLayerPush(
                        trackingData({
                            selection: `${category} | ${card.header}`,
                            link_url: getBaseUrlJoined(href),
                        })
                    );
                }}
                href={href}
                prefetch={false} // https://petsmart.atlassian.net/browse/SB-325
            >
                {imgSrc && <Image src={imgSrc} alt={card.image.webAltText} />}
                <Heading tagName="h3" size="body-bold">
                    {card.header}
                </Heading>
                {card.description && (
                    <TextPassage data-testid="sparky-card-out-of-stock" size="sm">
                        <p>{card.description}</p>
                    </TextPassage>
                )}
            </Link>
        </li>
    );
}
